export default {
    info: {},
    tenant: {},
    members: [],
    currencies: []
}



// WEBPACK FOOTER //
// ./src/modules/company/store/state.js